import type { EnhancedMatchUserData } from '@/components/@analitycs/push-ecommerce-event'

const WHITESPACE_REGEX = /\s+/

export interface EnhancedMatchSourceUser {
  fullName?: string | null
  email?: string | null
  phone?: string | null
  city?: string | null
  state?: string | null
  zip?: string | null
  country?: string | null
}

export function mapUserDataForEnhancedMatch(
  source: EnhancedMatchSourceUser
): EnhancedMatchUserData {
  const nameParts = (source.fullName ?? '')
    .trim()
    .split(WHITESPACE_REGEX)
    .filter(Boolean)
  const firstName = nameParts[0] || undefined
  const lastName = nameParts.slice(1).join(' ') || undefined

  return {
    email: source.email ?? undefined,
    phone: source.phone ?? undefined,
    firstName,
    lastName,
    city: source.city ?? undefined,
    state: source.state ?? undefined,
    zip: source.zip ?? undefined,
    country: source.country ?? undefined,
  }
}
